<template>
  <h5
    class="d-flex align-center gap-2 title"
    data-testid="group-column-selector-title"
  >
    <SoCheckbox
      v-model="allColumnsSelected"
      data-testid="group-column-selector-checkbox"
    />
    {{ columnConfig?.title }}
  </h5>
</template>
<script lang="ts">
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import { ComplaintsSelectorConfig } from "@/views/operations/complaints/components/OpsComplaintColumnSelector.vue"
  import { PropType } from "vue"
  import { IComplaint } from "@/models/complaint/complaint.types"

  export default {
    name: "OpsComplaintGroupColumnSelector",
    components: { SoCheckbox },
    props: {
      modelValue: {
        type: Array as PropType<(keyof IComplaint)[]>,
        default: () => [],
      },
      columnConfig: {
        type: Object as PropType<ComplaintsSelectorConfig | undefined>,
        default: () => undefined,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      allColumnsSelected: {
        get(): boolean {
          return !!this.columnConfig?.headers.every((h) =>
            this.modelValue.includes(h.key),
          )
        },
        set(isSelectAll: boolean) {
          const localHeaders =
            this.columnConfig?.headers.map((h) => h.key) || []
          const newValue = isSelectAll
            ? [...new Set([...this.modelValue, ...localHeaders])]
            : this.modelValue.filter((header) => !localHeaders.includes(header))

          this.$emit("update:modelValue", newValue)
        },
      },
    },
  }
</script>

<style scoped>
  .title {
    cursor: default;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
</style>
